<template>
    <div>

        <div class="position-relative">
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Contact us
                                </h1>
                                <p class="lead  text-white">
                                    We are happy to talk about how we can work together.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span class="span-150"></span>
                <span class="span-50"></span>
                <span class="span-50"></span>
                <span class="span-75"></span>
                <span class="span-100"></span>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1 text-center text-uppercase">Please fill the form below</h4>
                            <small class="category">Our solutions</small>
                            <div class="row">
                                <div class="col-sm-6">
                                <base-checkbox value="solutions_autonomous_driving" v-model="form.checkedAD">Autonomous driving</base-checkbox>
                                <base-checkbox value="solutions_smart_home" v-model="form.checkedSH">Smart Home</base-checkbox>
                                <base-checkbox value="solutions_manufacturing" v-model="form.checkedMF">Manufacturing</base-checkbox>
                                </div>
                                <div class="col-sm-6">
                                <base-checkbox value="solutions_smart_retail" v-model="form.checkedSR">Smart retail</base-checkbox>  
                                <base-checkbox value="solutions_mobile_apps" v-model="form.checkedMA">Mobile apps</base-checkbox>
                                <base-checkbox value="solutions_robotics" v-model="form.checkedRB">Robotics</base-checkbox>
                                </div>
                            </div>
                            <small class="category">Our services</small>
                            <div class="row">
                                <div class="col-sm-6">
                                <base-checkbox value="services_data_collection" v-model="form.checkedDCollection">Data collection</base-checkbox>
                                <base-checkbox value="services_data_cleaning" v-model="form.checkedDCleaning">Data cleaning</base-checkbox>
                                </div>
                                <div class="col-sm-6">
                                <base-checkbox value="services_data_annotation" v-model="form.checkedDAnnotation">Data annotation</base-checkbox>
                                <base-checkbox value="services_data_augmentation" v-model="form.checkedDAugmentation">Data augmentation</base-checkbox>
                                </div>
                            </div>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Your name"
                                        v-model="form.name"
                                        addon-left-icon="ni ni-single-02">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        v-model="form.email"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input alternative
                                        placeholder="Phone number"
                                        v-model="form.phone"
                                        @input="phoneNumber"
                                        addon-left-icon="ni ni-mobile-button">
                            </base-input>
                            <base-input alternative
                                        placeholder="Company name"
                                        v-model="form.company"
                                        addon-left-icon="ni ni-building">
                            </base-input>
                            <base-input class="mb-4">
                                <textarea 
                                    class="form-control form-control-alternative" 
                                    name="name"
                                    rows="4"
                                    cols="80" 
                                    placeholder="Type a message..."
                                    v-model="form.message">
                                </textarea>
                            </base-input>
                             <small class="text-light">{{indicator}}</small>
                            <base-button type="primary" round block  @click="sendMessage">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "contact",
  components: {

  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        checkedAD: false,
        checkedSH: false,
        checkedMF: false,
        checkedSR: false,
        checkedMA: false,
        checkedRB: false,
        checkedDCollection: false,
        checkedDCleaning: false,
        checkedDAnnotation: false,
        checkedDAugmentation: false,
      },
      interest_string: '',
      indicator:''
    };
  },
  methods: {
    isValidateEmail: function() {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.form.email);
    },
    isValidatePhone: function() {
        if (this.form.phone != "") {
            return this.form.phone.match(/\d/g).length===10;
        }
        return false;
    },
    phoneNumber() {
    	var x = this.form.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.form.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    async sendMessage(){
        this.indicator = "Sending message..."
        if (this.form.name === "") {
            this.indicator = "Please input your name!";
            return
        }
        if (this.isValidateEmail() === false) {
            this.indicator = "Please input a valid email address!";
            return
        }
        if (this.isValidatePhone() === false) {
            this.indicator = "Please input a valid phone number!";
            return
        }
        if (this.form.company === "") {
            this.indicator = "Please input your company name!";
            return
        }
        if (this.form.message === "") {
            this.indicator = "Please input your message!";
            return
        }

        this.interest_string = this.form.checkedAD ? '1':'0';
        this.interest_string += this.form.checkedSH ? '1':'0';
        this.interest_string += this.form.checkedMF ? '1':'0';
        this.interest_string += this.form.checkedSR ? '1':'0';
        this.interest_string += this.form.checkedMA ? '1':'0';
        this.interest_string += this.form.checkedRB ? '1':'0';
        this.interest_string += this.form.checkedDCollection ? '1':'0';
        this.interest_string += this.form.checkedDCleaning ? '1':'0';
        this.interest_string += this.form.checkedDAnnotation ? '1':'0';
        this.interest_string += this.form.checkedDAugmentation ? '1':'0';
                            
        axios.post('/feedback', {
            'Name': this.form.name,
            'Phone': this.form.phone,
            'Email': this.form.email,
            'Company': this.form.company,
            'Interest': this.interest_string,
            'Message': this.form.message
        })
        .then((response) => {
        
            if (response.status === 200 && response.data != null) {
            switch (response.data.code){
                case 200:
                    this.indicator = "We have received your message and will contact you as soon as possible！"
                    this.form.name = ""
                    this.form.company = ""
                    this.form.email = ""
                    this.form.phone = ""
                    this.form.message = ""
                    break
                default:
                    this.indicator = "Sever error, please try again later！"
            }
            }
        })
        .catch( error => {
            this.indicator = "Sever error, please try again later！"
        })
    }	
  }
};
</script>
